import styled, { css } from 'styled-components';
import { riseIn } from '@shared/theme/animations';

interface CardProps {
  $interactive?: boolean;
  $accent?: boolean;
  $delay?: number;
}

export const Card = styled.div<CardProps>`
  position: relative;
  background: ${({ theme }) => theme.colors.backgroundElevated};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.lg};
  padding: ${({ theme }) => theme.spacing(5)};
  box-shadow: ${({ theme }) => theme.shadow.sm};
  transition:
    transform ${({ theme }) => theme.motion.base} ${({ theme }) => theme.motion.easeOut},
    box-shadow ${({ theme }) => theme.motion.base} ${({ theme }) => theme.motion.easeOut},
    border-color ${({ theme }) => theme.motion.base} ${({ theme }) => theme.motion.easeOut};

  animation: ${riseIn} 420ms ${({ theme }) => theme.motion.easeOut} both;
  animation-delay: ${({ $delay = 0 }) => `${$delay}ms`};

  /* Signature accent line — slides in from the left on hover for interactive cards. */
  ${({ $accent, theme }) =>
    $accent &&
    css`
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 18%;
        bottom: 18%;
        width: 3px;
        border-radius: ${theme.radius.pill};
        background: ${theme.colors.gradient.brand};
        transform: scaleY(0);
        transform-origin: top;
        transition: transform ${theme.motion.base} ${theme.motion.spring};
      }
    `}

  ${({ $interactive, theme }) =>
    $interactive &&
    css`
      cursor: pointer;
      &:hover {
        transform: translateY(-3px);
        box-shadow: ${theme.shadow.lg};
        border-color: ${theme.colors.borderStrong};
      }
      &:hover::before {
        transform: scaleY(1);
      }
    `}
`;

export const CardTitle = styled.h3`
  margin: 0 0 ${({ theme }) => theme.spacing(2)};
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const CardSubtitle = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
